var PathStore = require('../stores/PathStore');
var makePath = require('./makePath');

/**
 * Transitions to the URL specified in the arguments by replacing
 * the current URL in the history stack.
 */
function replaceWith(to, params, query) {
  PathStore.replace(makePath(to, params, query));
}

module.exports = replaceWith;



//////////////////
// WEBPACK FOOTER
// ./~/react-router/modules/helpers/replaceWith.js
// module id = 212
// module chunks = 0